import React, {
  useState,
  useEffect,
} from 'react';
import { withRouter } from 'react-router-dom';
import {
  Box,
  Container,
} from '@material-ui/core';
import PropTypes from 'prop-types';
import Page from '../../../../components/Layout/Page';
import useIsMountedRef from '../../../../hooks/useIsMountedRef';
import UserEditForm from './UserEditForm';
import Header from './Header';

import { getUserDetail, getUserStores } from '../../../../requests/api/users';
import storeRequest from '../../../../requests/api/store';

import useStyles from './styles';

function UserEditView(props) {
  const classes = useStyles();
  const isMountedRef = useIsMountedRef();
  const [user, setUser] = useState();
  const [stores, setStores] = useState([]);
  const [userStores, setUserStores] = useState([]);

  useEffect(() => {
    const getUser = async () => {
      const response = await getUserDetail(props.match.params.id);

      if (response.success && isMountedRef.current) {
        setUser(response.user);
        const [storeResponse, userStoresResponse] = await Promise.all([
          storeRequest.getStoresPerPage(0, '', '', response.user.clientId || ''),
          getUserStores(response.user.id),
        ]);
        if (storeResponse.success) {
          setStores(storeResponse.allStores || []);
        }
        if (userStoresResponse.success) {
          setUserStores(userStoresResponse.stores || []);
        }
      }
    };

    getUser();
  }, [props]);

  if (!user) {
    return null;
  }

  return (
    <Page
      className={classes.root}
      title="Editar Usuario"
    >
      <Container maxWidth={false}>
        <Header />
        <Box mt={3}>
        <UserEditForm user={user} stores={stores} userStores={userStores} />
        </Box>
      </Container>
    </Page>
  );
}

UserEditView.propTypes = {
  match: PropTypes.any,
};

export default withRouter(UserEditView);
